export default __webpack_public_path__ + "static/media/Love10.f296aa2b.png";